import { render, staticRenderFns } from "./HomeInfo.vue?vue&type=template&id=fbdf2a3c&scoped=true&"
import script from "./HomeInfo.vue?vue&type=script&lang=js&"
export * from "./HomeInfo.vue?vue&type=script&lang=js&"
import style0 from "./HomeInfo.vue?vue&type=style&index=0&id=fbdf2a3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdf2a3c",
  null
  
)

export default component.exports